export const UPDATE_STATISTICS = 'casino-heroes/home/UPDATE_STATISTICS'
export const UPDATE_GAMES = 'casino-heroes/home/UPDATE_GAMES'
